import NewUser from './NewUser'

export default NewUser



// WEBPACK FOOTER //
// ./src/components/Users/New/index.js